import React, { useRef, useState } from 'react';
import authorize, { authorizeUser } from '../../auth/authorize';
import styles from './index.module.scss';

// Components
import { Modal, Form, Button, InputGroup } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner';

// Constant
import { INCORRECT_CREDENTIALS, VALID_AUTHENTICATION } from '../../constants/status';

const AuthModal = (props) => {
    const [newLogin, setNewLogin] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [wrongPass, setWrongPass] = useState(false);
    const [loading, setLoading] = useState(false);

    const passwordInput = useRef();

    const focusPassword = () => {
        passwordInput.current.focus();
    }

    const onEnterPressed = (e) => {
        if (e.key === "Enter") {
            submitAuthorization();
        }
    }

    const onPasswordChanged = (e) => {
        setPassword(e.target.value);
        setWrongPass(false);
    }

    const submitAuthorization = async () => {
        setLoading(true);
        let success;

        if (newLogin)
            success = await authorizeUser(username, password, props.updateUserData, props.func);
        else
            success = await authorize(password, props.func);

        // If everything went fine with the request and it is a new Login
        if (success && newLogin) {
            switch (success.status) {
                case INCORRECT_CREDENTIALS:
                    setWrongPass(true);
                    break;
                case VALID_AUTHENTICATION:
                    clearInputs();
                    // Assing new token and refresh Account in the header
                    sessionStorage.setItem('auth-token', success.token);
                    break;
                default:
            }



            // If everything went fine and it is the same account logged in
        } else if (success && !newLogin) {
            clearInputs();
        } else {
            setWrongPass(true);
        }

        setLoading(false);
    }

    const clearInputs = () => {
        setUsername('');
        setPassword('');
        setNewLogin(false);
        props.hide();
    }

    return (
        <Modal show={props.show} onEntered={focusPassword} hide={props.hide} onExited={clearInputs} backdrop="static">
            <Modal.Header>
                <Modal.Title className={styles.Center}>{newLogin ? "Confirma tu Usuario y Contraseña" : "Por favor confirmar con tu contraseña"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={(e) => e.preventDefault()}>
                    {!newLogin &&
                        <>
                            <h4 className={styles.FullName}>{`${props.userData.name} ${props.userData.lastname}`}</h4>
                            {!props.signInDisabled && <div className={styles.NotYouLink__container}>
                                <span
                                    className={[styles.NotYouLink, 'text-primary'].join(" ")}
                                    onClick={() => setNewLogin(true)}>¿No eres tu?</span>
                            </div>}
                        </>}
                    {newLogin && <Form.Group>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text className={styles.PrependText}>Usuario</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)} />
                        </InputGroup>
                    </Form.Group>}
                    <Form.Group style={{ marginTop: props.signInDisabled ? '1rem' : null }}>
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text className={styles.PrependText}>Contraseña</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                type="password"
                                ref={passwordInput}
                                value={password}
                                onKeyDown={onEnterPressed}
                                onChange={onPasswordChanged}
                                isInvalid={wrongPass} />
                        </InputGroup>
                        <Form.Control.Feedback type="invalid">Contraseña incorrecta</Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={props.hide}>Cancelar</Button>
                <Button variant="primary" onClick={submitAuthorization}>
                    <span>Confirmar</span>
                    {loading && <LoadingSpinner size="sm" inButton />}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AuthModal;